// Lab (lab/iphone-40-no-merge): vult secties die de server als placeholder rendert
// (<div data-hds-lazy-section="<section-id>">, bv. sections/product-list.liquid op categorie-hubs)
// via de Section Rendering API zodra ze binnen ~1,5 scherm komen, of na het laden als de pagina stil is.
// Scripts in de opgehaalde HTML draaien niet via innerHTML; die zetten we opnieuw neer.

/** @param {HTMLElement} plek */
async function vul(plek) {
  if (plek.dataset.hdsBezig) return;
  plek.dataset.hdsBezig = '1';
  const id = plek.dataset.hdsLazySection || '';
  const url = new URL(location.href);
  url.hash = '';
  url.searchParams.set('sections', id);
  try {
    const res = await fetch(url, { credentials: 'same-origin' });
    const html = res.ok ? (await res.json())[id] : null;
    if (!html) throw new Error(`lazy section ${id}: ${res.status}`);
    const t = document.createElement('template');
    t.innerHTML = html;
    const bron = t.content.querySelector('[id^="shopify-section-"]');
    const doel = plek.closest('[id^="shopify-section-"]');
    if (!bron || !doel) return;
    doel.replaceChildren(...bron.childNodes);
    for (const oud of doel.querySelectorAll('script')) {
      const nieuw = document.createElement('script');
      for (const a of oud.attributes) nieuw.setAttribute(a.name, a.value === 'hds/deferred-module' ? 'module' : a.value);
      nieuw.textContent = oud.textContent;
      oud.replaceWith(nieuw);
    }
  } catch (err) {
    console.error(err);
    delete plek.dataset.hdsBezig;
  }
}

const io = new IntersectionObserver(
  (entries) => entries.forEach((e) => e.isIntersecting && (io.unobserve(e.target), vul(/** @type {HTMLElement} */ (e.target)))),
  { rootMargin: '150% 0px' }
);
const plekken = () => /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll('[data-hds-lazy-section]'));
plekken().forEach((p) => io.observe(p));
const naLaden = () => (window.requestIdleCallback || ((cb) => setTimeout(cb, 500)))(() => plekken().forEach(vul), { timeout: 4000 });
if (document.readyState === 'complete') setTimeout(naLaden, 1500);
else window.addEventListener('load', () => setTimeout(naLaden, 1500), { once: true });
